import { ActionTypes } from '../actions/summaries_index'
import { ActionTypes as LeaderboardActionTypes } from '../actions/leaderboardV2_index'

// One entry per OPEN summary, keyed by summary key (playerPoints, ...) —
// entry presence is the open/selected state, exactly like the event slice.
const initialState = {}

export default function summariesReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_SUMMARY_REQUEST:
      return {
        ...state,
        [action.payload.summaryKey]: { loading: true, error: null, data: null },
      }

    case ActionTypes.FETCH_SUMMARY_SUCCESS:
      return {
        ...state,
        [action.payload.summaryKey]: { loading: false, error: null, data: action.payload.data },
      }

    case ActionTypes.FETCH_SUMMARY_FAILURE:
      return {
        ...state,
        [action.payload.summaryKey]: { loading: false, error: action.payload.error, data: null },
      }

    case ActionTypes.CLOSE_SUMMARY: {
      const next = { ...state }
      delete next[action.payload.summaryKey]
      return next
    }

    case ActionTypes.CLEAR_SUMMARIES: {
      const { exceptKey } = action.payload
      const kept = exceptKey && state[exceptKey]
      return kept ? { [exceptKey]: kept } : {}
    }

    // Summary data is round-specific — a round change closes everything.
    case LeaderboardActionTypes.SET_ROUND_ID:
    case LeaderboardActionTypes.COMMIT_EVENTS:
      return {}

    default:
      return state
  }
}
